import { bindActionCreators as bindActions } from "redux";
import { connect } from "react-redux";

import { getCity, isPremiumIn } from "../selectors";
import { goToScreen } from "../modules/modal";
import PremiumAlert from "../components/PremiumAlert";

const props = (state) => ({
  isLoggedIn: state.auth.isLoggedIn,
  isPremium: state.auth.isPremium,
  isPremiumIn: isPremiumIn(state),
  city: getCity(state),
});

const actions = (dispatch) => bindActions({ goTo: goToScreen }, dispatch);

export default connect(
  props,
  actions
)(PremiumAlert);
